import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';
import { BodyRegularSemiBold, Heading6 } from '@src/fonts/typography/Typography';

export const Container = styled.div`
  ${BodyRegularSemiBold}
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
  transition: background-color 0.3s ease-in;
  &:hover {
    background-color: #cdcdcd;
  }
  ${device.mobile} {
    width: calc(26px * 3);
  }
`;

export const Content = styled.div`
  ${Heading6}
  color: ${LayoutColors.blackMain}
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
  cursor: pointer;
  transition: background-color 0.3s ease-in;
  &:hover {
    background-color: #cdcdcd;
  }
`;
